import { render, staticRenderFns } from "./IcdTreeElement.vue?vue&type=template&id=31b9df17&scoped=true&"
import script from "./IcdTreeElement.vue?vue&type=script&lang=js&"
export * from "./IcdTreeElement.vue?vue&type=script&lang=js&"
import style0 from "./IcdTreeElement.vue?vue&type=style&index=0&id=31b9df17&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b9df17",
  null
  
)

export default component.exports